import c from 'classnames';
import Image from 'next/image';
import { Play } from 'phosphor-icons';
import { AssetMediaType, GallerySlideData } from './GallerySlide';

type GalleryThumbnailButtonProps = {
  id: string;
  index: number;
  slide: GallerySlideData;
  currentSlide: number;
  setCurrentSlide: (index: number) => void;
  aspectRatio?: 'aspect-video' | 'aspect-[4/3]' | 'aspect-[3/2]';
};

export const GalleryThumbnailButton = ({
  id,
  index,
  slide,
  currentSlide,
  setCurrentSlide,
  aspectRatio = 'aspect-video',
}: GalleryThumbnailButtonProps) => {
  const label = slide.thumbnailLabel ?? slide.alt;
  return (
    <button
      id={id}
      data-test={id}
      aria-current={currentSlide === index}
      aria-label={label}
      onClick={() => setCurrentSlide(index)}
      className={c(
        'focus-outline bg-gray-100 lg:bg-gray-100 relative w-20 flex-shrink-0 rounded-thumbs px-2 outline-2 lg:w-full',
        aspectRatio,
        {
          'outline outline-offset-2 outline-blue': currentSlide === index,
          'hover:outline hover:outline-[2px] hover:outline-blue':
            currentSlide !== index,
        }
      )}
    >
      {slide.type === AssetMediaType.ATTACHMENT_VIDEO && (
        <div className="absolute top-0 z-10 flex h-full w-full items-center justify-center rounded-thumbs bg-black/40 pl-2 pr-2 text-white">
          <Play size={20} weight="fill" />
        </div>
      )}
      <Image
        fill
        src={slide.thumbnail ? slide.thumbnail : slide.src}
        sizes="80px, (min-width: 1024px) 8vw"
        alt={label ?? ''}
        className="rounded-thumbs object-cover"
      />
    </button>
  );
};
